import { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import routes from '../../utils/router';
import { Collapse, Spin } from "antd";
import Svg from "../Svg";
import StringHelper from "../../helpers/StringHelper";
import { PILGRIMAGE, PILGRIMAGE_ONLINE } from "../../utils/constants";
const { Panel } = Collapse;

const ProfileMenuContent = ({ setMobileMenuProfileDrawer, mobileMenuProfileDrawer }) => {
    const liRef = useRef(null);
    const descriptionLinks = routes().links.map((i, index) => ({ ...i, svg: i.name, id: index }));
    const [BranchWithShowType, setBranchWithShowType] = useState();
    const [business, setBusiness] = useState({})
    const [userInfo, setUserInfo] = useState({})
    const [userInfoLoading, setUserInfoLoading] = useState({})
    const [balance, setBalance] = useState({})
    const [isLoggedIn, setIsLoggedIn] = useState('')
    const [balanceLoading, setBalanceLoading] = useState(false);
    const walletPermission = userInfo?.Resources?.find(resource => resource === "UseWallet");
    const balanceLengthCondition = useMemo(() => balance?.Balance?.toString().length > 6, [balance])


    useEffect(() => {
        if (localStorage && localStorage.getItem('app-store')) {
            const store = JSON.parse(localStorage.getItem('app-store'))
            if (store) {
                console.log('✌️store --->', store)
                setBusiness(store?.state?.business)
                setBranchWithShowType(store?.state?.business?.BranchWithShowType)
                setUserInfo(store?.state?.user?.info?.data)
                setIsLoggedIn(store?.state?.auth?.userToken)
                setBalanceLoading(store?.state?.user?.wallet?.loading)
            }
        }
    }, [localStorage])

    let branches = []
    BranchWithShowType?.map((item) => {
        let rec = routes().links.filter((link) => { return item.Branch === link?.name })[0]
        const desc = descriptionLinks.filter(item => item.name === rec?.name)[0];
        if (desc) {
            if (branches?.filter((link) => link.name === PILGRIMAGE || link.name === PILGRIMAGE_ONLINE)[0] && (desc.name === PILGRIMAGE || desc.name === PILGRIMAGE_ONLINE))
                return
            else
                branches.push(desc)
        }
    })

    // Specifications manipulation:
    let Specifications = userInfo?.UserName;
    if (Specifications && Specifications.length > 20) {
        Specifications = Specifications.substr(0, 17) + " ..."
    } else if (Specifications && Specifications.length <= 2) {
        
    } else Specifications = (userInfo?.FirstName && userInfo.LastName) && userInfo.FirstName + ' ' + userInfo.LastName;

    // listener for removing null value of balance element from the DOM
    useEffect(() => {
        if (balance === null) {
            const div = liRef?.current;
            if (div) {
                div?.parentNode?.removeChild(div);
            }
        };
    }, [balance])

    // const branchess = branches?.filter((link) => link.name !== BARAN_LIFE);

    return (
        <ul className="nav">
            <li className="p-3 w-100 cursor-pointer" onClick={() => setMobileMenuProfileDrawer(false)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.75 12.75H20.25C20.6642 12.75 21 12.4142 21 12C21 11.5858 20.6642 11.25 20.25 11.25H3.75C3.33579 11.25 3 11.5858 3 12C3 12.4142 3.33579 12.75 3.75 12.75Z" fill="#1C1C1C" /><path d="M19.1893 12L12.9697 18.2197C12.829 18.3603 12.75 18.5511 12.75 18.75C12.75 18.9489 12.829 19.1397 12.9697 19.2803C13.1103 19.421 13.3011 19.5 13.5 19.5C13.6989 19.5 13.8897 19.421 14.0303 19.2803L20.7803 12.5303C21.0732 12.2374 21.0732 11.7626 20.7803 11.4697L14.0303 4.71967C13.8897 4.57902 13.6989 4.5 13.5 4.5C13.3011 4.5 13.1103 4.57902 12.9697 4.71967C12.829 4.86032 12.75 5.05109 12.75 5.25C12.75 5.44891 12.829 5.63968 12.9697 5.78033L19.1893 12Z" fill="#1C1C1C" /></svg>
            </li>

            <li className="width-content w-100">
                {isLoggedIn && <ul>
                    <li onClick={() => setMobileMenuProfileDrawer(false)} className="nav-titles d-flex align-items-center  ">
                        <a href="/profile/bought">
                            <span className="p-0">
                                <Svg name="profile-myinsurance" />
                            </span>
                            <span className='darker-surface-color'>
                                بیمه های من
                            </span>
                        </a>
                        {userInfo && userInfo?.InsuranceNumber > 0 ? <div className="unfinished__purchases">
                            {userInfo && StringHelper.getFarsiNum(userInfo.InsuranceNumber)}
                        </div> : ""}
                    </li>
                    {business.hasWallet && walletPermission ?
                        <Spin className="nav-titles" spinning={userInfoLoading || balanceLoading}>
                            <li ref={liRef} onClick={() => setMobileMenuProfileDrawer(false)} className={`nav-titles d-flex 
                            ${balanceLengthCondition ? "more-length-balance justify-content-between" : "align-items-center"}
                             ${!walletPermission ? "d-none" : ""}`}>
                                <a href="/profile/wallet">
                                    {/* <Link to="#"> */}
                                    <span className="p-0 darker-surface-color">
                                        <Svg name="profile-wallet" className="wallet__icon" />
                                        {/* <Svg name="walletHeader" className="wallet__icon" /> */}
                                    </span>
                                    <span className={`${balanceLengthCondition ? "wallet__title" : "ml-1"} darker-surface-color`}>
                                        کیف پول
                                    </span>
                                </a>
                                {balance?.Balance !== null ?
                                    <span className="wallet__balance">
                                        <span className="wallet__balance__amount">{StringHelper.currencyFormat(Math.round(balance?.Balance / 10))}</span>
                                        <span className="wallet__balance__title">{" "}تومان</span>
                                    </span>
                                    : ""}
                            </li>
                        </Spin>
                        : ""}
                    <li onClick={() => setMobileMenuProfileDrawer(false)} className="nav-titles  ">
                        <a href="/profile/notifications">
                            <span className="p-0">
                                <Svg name="notifications-outlined" />
                            </span>
                            {userInfo?.NewNoticeCount > 0 ?
                                <span className="simple-dot-sidebar" />
                                : ""}
                            <span className='darker-surface-color'>
                                اعلانات
                            </span>
                        </a>
                    </li>
                    <li onClick={() => setMobileMenuProfileDrawer(false)} className="nav-titles d-flex align-items-center  ">
                        <a href="/profile/installments">
                            <span className="p-0">
                                <Svg name="profile-installments" />
                            </span>
                            <span className='darker-surface-color'>
                                قسط های من
                            </span>
                        </a>
                    </li>
                    {!isLoggedIn && <li onClick={() => setMobileMenuProfileDrawer(false)} className="nav-titles">
                        <a data-tracking-id="track-order" href={window.location.origin + "/TrackingRequest"}>
                            <Svg name="menu-tracking" className="fill-darker-surface-color" />
                            <span className="darker-surface-color">
                                پیگیری خرید
                            </span>
                        </a>
                    </li>}
                    <li className="nav-titles logout-mobile">
                        <a onClick={() => {
                            if (typeof window !== 'undefined') {
                                let local

                                if (
                                    JSON.parse(localStorage?.getItem('app-store'))
                                ) {
                                    local = JSON.parse(
                                        localStorage?.getItem('app-store')
                                    )

                                    local.state.auth.mobile = ''
                                    local.state.auth.userToken = ''
                                    local.state.user.info.data.UserName = ''
                                    localStorage.setItem(
                                        'app-store',
                                        JSON.stringify(local)
                                    )
                                } else {
                                    local = {
                                        state: {
                                            auth: {
                                                mobile: '',
                                                userToken: ''
                                            },
                                            user: {
                                                info: {
                                                    data: {
                                                        UserName: ''
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            setTimeout(() => {
                                window.location.reload()
                                // message.success("شما با موفقیت خارج شدید")
                            }, 2000)

                            setTimeout(() => {
                                setMobileMenuProfileDrawer(false)
                            }, 500);
                        }} href={window.location.origin}>
                            <span className="p-0">
                                <Svg name="exit-outlined" />
                            </span>
                            <span className='darker-surface-color'>
                                خروج
                            </span>
                        </a>
                    </li>
                </ul>
                }

            </li>

            {!isLoggedIn && <>
                <li className="nav-titles">
                    <Collapse
                        expandIcon={({ isActive }) => isActive ? <Svg name="expand-icon-mobile" className="fill-darker-surface-color rotate-180" /> : <Svg name="expand-icon-mobile" className="fill-darker-surface-color rotate-0" />}
                        ghost
                        bordered={false} defaultActiveKey={["0"]}>
                        <Panel
                            header={<div>
                                <Svg name="menu-insurances" className="fill-darker-surface-color" />
                                <span className="darker-surface-color">
                                    بیمه‌ها
                                </span>
                            </div>}
                            key="1">
                            <span>
                                {branches?.length && branches.map((link, index) => (
                                    <li onClick={() => {
                                        setMobileMenuProfileDrawer(false)
                                    }
                                    } key={index} className="nav-items mb-1">
                                        <a href={window.location.origin + link.path}>
                                            {link.insuranceFaName}
                                        </a>
                                    </li>
                                )
                                )}
                            </span>
                        </Panel>
                    </Collapse>

                </li>
            </>}

            {!isLoggedIn && <>
                <li onClick={() => setMobileMenuProfileDrawer(false)} className="nav-titles">
                    <a data-tracking-id="track-order" href={window.location.origin + "/TrackingRequest"}>
                        <Svg name="menu-tracking" className="fill-darker-surface-color" />
                        <span className="darker-surface-color">
                            پیگیری خرید
                        </span>
                    </a>
                </li>
                <li onClick={() => setMobileMenuProfileDrawer(false)} className="nav-titles">
                    <a target="_blank"
                        href="https://bimeh.com/marketers/">
                        <Svg name="menu-promotor" className="fill-darker-surface-color" />
                        <span style={{ fontWeight: 550 }} className='darker-surface-color' >
                            کسب درآمد کنید
                        </span>
                    </a>
                </li>
                <li onClick={() => setMobileMenuProfileDrawer(false)} className="nav-titles">
                    <a target="_blank" href="https://bimeh.com/mag/" >
                        <Svg name="menu-mag" className="fill-darker-surface-color" />
                        <span className="darker-surface-color">
                            مجله بیمه دات کام
                        </span>
                    </a>
                </li>
            </>}
        </ul>
    );
};
export default ProfileMenuContent;